import { createI18n } from 'vue-i18n';
import ui from './content/i18n/ui.json';

const LANGS = ['nl', 'en', 'es'];

// Get saved language or default to 'nl'
function getSavedLanguage() {
    if (typeof window !== 'undefined' && window.localStorage) {
        try {
            const lang = localStorage.getItem('language');
            return (lang && LANGS.includes(lang)) ? lang : 'nl';
        } catch (e) {
            return 'nl';
        }
    }
    return 'nl';
}

// The UI texts are stored CMS-friendly: every string is an object with the three
// languages side by side ({ nl, en, es }), managed via the CMS at /admin.
// vue-i18n expects one message tree per locale, so we pivot the combined tree
// into { nl: {...}, en: {...}, es: {...} } at load time.
function isLeaf(node) {
    if (!node || typeof node !== 'object' || Array.isArray(node)) return false;
    const keys = Object.keys(node);
    return keys.length > 0 && keys.every((k) => LANGS.includes(k));
}

function pick(node, lang) {
    if (isLeaf(node)) {
        return node[lang] ?? node.en ?? node.nl ?? '';
    }
    if (node && typeof node === 'object' && !Array.isArray(node)) {
        const out = {};
        for (const key of Object.keys(node)) out[key] = pick(node[key], lang);
        return out;
    }
    return node;
}

// Zoekt één tekst op in de CMS-teksten, los van de taal die de bezoeker gebruikt.
// Gebruikt door het contactformulier: de mail naar Mirai Motion moet leesbare
// tekst bevatten ("Anime of manga events") in plaats van de technische sleutel
// uit de keuzelijst ("animeManga"). Standaard Nederlands, want de mailbox is dat ook.
export function uiText(path, lang = 'nl') {
    const node = path.split('.').reduce((acc, key) => (acc == null ? acc : acc[key]), ui);
    if (!isLeaf(node)) return '';
    return node[lang] || node.nl || node.en || '';
}

const messages = LANGS.reduce((acc, lang) => {
    acc[lang] = pick(ui, lang);
    return acc;
}, {});

const i18n = createI18n({
    locale: getSavedLanguage(),
    fallbackLocale: 'en',
    messages,
    legacy: true, // Use legacy mode for Options API support ($t in templates)
    allowComposition: true, // Also allow Composition API
    globalInjection: true, // Make $t available globally
    warnHtmlMessage: false,
    missingWarn: false,
    fallbackWarn: false
});

export default i18n;
